import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import PropTypes from 'prop-types';
import { Button, Modal, Spacer, Typography } from '@telus-uds/components-web';

import { useLocalizedStringsContext } from '../../../context/LocalizedStringsContext';
import { businessConnectContactCentreOnlineTool } from '../../../utils/constant';
import { Button as ActionButton } from './css';

const Continue = ({ orderData, status }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const localizedStrings = useLocalizedStringsContext();
  const {
    srtDashboard: { confirmationDialog, continueLabel, editOrder },
    formButtons: { confirmButtonLabel, cancelButtonLabel },
    callCentre: {
      salesRepDashboard: { confirmationToModifyTheOrder }
    }
  } = localizedStrings;
  const { locale, categoryName, id } = orderData;
  const history = useHistory();

  const getLabel = () => {
    let label;

    switch ((status || '').toUpperCase()) {
      case 'INCOMPLETE':
        label = continueLabel;
        break;
      case 'SUBMITTED':
        label = editOrder;
        break;
      default:
        label = continueLabel;
    }
    return label;
  };

  const handleModifyQuote = () => {
    setIsModalOpen(false);
    history.push({
      pathname: `/${locale}/${categoryName}/${businessConnectContactCentreOnlineTool}`,
      search: `?orderId=${id}`
    });
    window.location.reload();
  };

  return (
    <>
      <ActionButton onClick={() => setIsModalOpen(true)}>{getLabel()}</ActionButton>
      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      >
        <Typography variant={{ size: 'h2' }}>{confirmationDialog}</Typography>
        <Spacer space={1} />
        <p>{confirmationToModifyTheOrder}</p>
        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'flex-end', marginTop: '1rem' }}>
          <Button
            type="button"
            variant={{ priority: 'low' }}
            onPress={() => setIsModalOpen(false)}
          >
            {cancelButtonLabel}
          </Button>
          <Button
            type="button"
            variant={{ priority: 'high' }}
            onPress={handleModifyQuote}
          >
            {confirmButtonLabel}
          </Button>
        </div>
      </Modal>
    </>
  );
};

Continue.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.object).isRequired,
  status: PropTypes.string.isRequired
};

export default Continue;
